import React from 'react';
import { HelpCircle, PlayCircle, TrendingUp, Eye } from 'lucide-react';

const Help = () => {
  return (
    <div className="page-section">
      <div style={{ textAlign: 'center', marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '8px' }}>
          Help & Frequently Asked Questions
        </h2>
        <p style={{ fontSize: '16px', color: 'var(--text-secondary)' }}>
          Get help with using Binance Analytics Pro
        </p>
      </div>

      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <div className="dashboard-card">
            <div className="card-header">
              <h3>
                <PlayCircle size={16} style={{ marginRight: '8px', color: 'var(--accent-gold)' }} />
                Getting Started
              </h3>
            </div>
            <div className="card-content">
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <div style={{ borderLeft: '3px solid var(--accent-gold)', paddingLeft: '16px' }}>
                  <h4 style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '4px' }}>
                    How to start price analysis?
                  </h4>
                  <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: 0 }}>
                    Navigate to Price Analysis, enter a trading pair, select time period, and click Analyze.
                  </p>
                </div>
                <div style={{ borderLeft: '3px solid var(--accent-gold)', paddingLeft: '16px' }}>
                  <h4 style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '4px' }}>
                    Setting up OI monitoring
                  </h4>
                  <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: 0 }}>
                    Go to OI Monitoring, configure thresholds, and click Start Monitoring to begin real-time tracking.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="dashboard-card">
            <div className="card-header">
              <h3>
                <TrendingUp size={16} style={{ marginRight: '8px', color: 'var(--accent-gold)' }} />
                Price Analysis
              </h3>
            </div>
            <div className="card-content">
              <div style={{ borderLeft: '3px solid var(--accent-gold)', paddingLeft: '16px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '4px' }}>
                  Understanding heatmaps
                </h4>
                <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: 0 }}>
                  Heatmaps show the frequency of daily highs and lows at different times, helping identify optimal trading windows.
                </p>
              </div>
            </div>
          </div>

          <div className="dashboard-card">
            <div className="card-header">
              <h3>
                <Eye size={16} style={{ marginRight: '8px', color: 'var(--accent-gold)' }} />
                OI Monitoring
              </h3>
            </div>
            <div className="card-content">
              <div style={{ borderLeft: '3px solid var(--accent-gold)', paddingLeft: '16px' }}>
                <h4 style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text-primary)', marginBottom: '4px' }}>
                  What are anomalies?
                </h4>
                <p style={{ fontSize: '13px', color: 'var(--text-secondary)', margin: 0 }}>
                  Anomalies are unusual changes in open interest that exceed your configured thresholds, potentially indicating market shifts.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help